<template>
  <div class="teacher-evaluation">
    <van-nav-bar title="教师评价" left-arrow @click-left="$router.back()" />
    <van-skeleton title :row="3" :loading="loading" style="margin-top: 40px">
      <!-- 显示教师信息 -->
      <template v-if="teacherInfo">
        <div class="custom-card" @click="goToTeacherDetail(teacherInfo.id)">
          <!-- <img :src="teacherInfo.avatar" class="avatar" /> -->

          <van-image :src="teacherInfo.avatar" class="avatar" radius="5%" />
          <div class="card-info">
            <p class="name">{{ teacherInfo.name }}</p>
            <p class="major">专业：{{ teacherInfo.major }}</p>
            <p class="admission">入园时间：{{ teacherInfo.admissiontime }}</p>
          </div>
        </div></template
      >
      <van-empty v-else description="暂无教师信息" />
      <van-form @submit="onSubmit">
        <van-field
          v-model="form.name"
          label="姓名"
          placeholder="请输入姓名"
          required
        />
        <van-field
          v-model="form.phone"
          label="手机号"
          placeholder="请输入手机号"
          :rules="[{ pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号' }]"
          required
        />
        <van-field
          v-model="form.content"
          label="评价内容"
          placeholder="请输入评价内容"
          type="textarea"
          rows="3"
          :rules="[{ pattern: /^.{6,}$/, message: '评价字数太少' }]"
          required
        />
        <van-button
          type="primary"
          block
          native-type="submit"
          :disabled="!isFormValid"
        >
          提交评价
        </van-button>
      </van-form>
    </van-skeleton>
  </div>
</template>
  
  <script>
import api from "@/api";

export default {
  name: "TeacherEvaluation",
  data() {
    return {
      form: {
        name: "",
        phone: "",
        content: "",
      },
      teacherInfo: null,
      loading: true, // 控制加载状态
    };
  },
  computed: {
    isFormValid() {
      return (
        this.form.name &&
        this.form.phone &&
        this.form.content &&
        this.teacherInfo
      );
    },
  },
  mounted() {
    this.fetchTeacherDetail();
  },
  methods: {
    async fetchTeacherDetail() {
      const { id } = this.$route.params;
      console.log("随机教师id", id);
      try {
        const res = await api.getTeacherDetail({ id });
        if (res.data.data && res.data.success) {
          console.log("data", res.data.data);
          this.teacherInfo = res.data.data;
        } else {
          this.$toast.fail("未找到相关教师信息");
        }
      } catch (err) {
        this.$toast.fail("加载教师信息失败");
      } finally {
        this.loading = false; // 设置加载状态为false
      }
    },

    async onSubmit() {
      if (!this.isFormValid) {
        this.$toast.fail("请填写完整评价信息");
        return;
      }

      this.$dialog
        .confirm({
          title: "提交评价",
          message: "确定提交评价吗？",
        })
        .then(() => {
          // on confirm
          console.log("on.confirm");
          const params = {
            teacher_id: this.teacherInfo.id,
            name: this.form.name,
            phone: this.form.phone,
            content: this.form.content,
          };
          try {
            api.postEvaluation(params).then((res) => {
              if (res.data.success) {
                // this.$toast.success("评价提交成功");
                this.form.name = "";
                this.form.phone = "";
                this.form.content = "";
                // this.teacherInfo = null;
                this.$dialog.alert({
                  title: "评价成功",
                });
              } else {
                console.log("评价提交失败", res);
                this.$dialog.alert({
                  title: "评价失败",
                  message: res.data.msg,
                });
              }
            });
          } catch (err) {
            // this.$toast.fail("提交失败");
            this.$dialog.alert({
              title: "评价失败",
            });
          }
        })
        .catch(() => {
          // on cancel
          console.log("on.cancel");
        });
    },

    goToTeacherDetail(id) {
      console.log("id", id);
      this.$router.push({ path: `/teacherdetail/${id}` });
    },
  },
};
</script>
  
  <style scoped>
.teacher-evaluation {
  padding: 20px;
  margin-bottom: 20px;
}
.qr-scan-container {
  margin-top: 20px;
  text-align: center;
}
.avatar {
  width: 66px;
  height: 100px;
  border-radius: 50%;
  margin-right: 20px;
}
.custom-card {
  display: flex;
  align-items: center;
  background: #fff;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  margin-top: 15px;
  margin-bottom: 15px;
  cursor: pointer;
}
.card-info {
  flex-grow: 1;
}
.name {
  font-weight: bold;
  font-size: 16px;
}
.major,
.admission {
  color: #666;
}
</style>
  